{
  "ApprovePlan": {
    "Content": "You are about to approve this investment plan. Once approved, the plan will be finalized and no further changes can be made.",
    "ErrorToastMessage": "Error approving plan. Please try again later.",
    "SuccessToastMessage": "Plan approved successfully.",
    "Title": "Approve Plan"
  },
  "Forbidden": {
    "Message": "You don't have permission to access the Investtool."
  },
  "DenyPlan": {
    "ErrorToastMessage": "Error denying plan. Please try again later.",
    "SuccessToastMessage": "Plan denied successfully."
  },
  "EmptyState": {
    "NoData": "No data available",
    "NoPlans": "No plans found",
    "NoTasks": "No tasks available",
    "NoResults": "No results found",
    "NoMembers": "No members invited yet",
    "NoTemplates": "No templates available",
    "NoTemplatesDescription": "Create a template to define country-specific costs and delivery times.",
    "NoFiscalYears": "No fiscal years available",
    "NoFiscalYearsDescription": "Create a fiscal year to start planning your investments."
  },
  "AvailabilityState": {
    "Existing": "Existing",
    "Insufficient": "Insufficient",
    "NotApplicable": "Not Applicable",
    "NotExisting": "Not Existing",
    "Unknown": "Not set"
  },
  "BudgetInput": {
    "BudgetProposal": "Save and Request Changes",
    "CreateNewVersion": "Create a new version of the plan and inform requester about the change",
    "ErrorToastMessage": "Error requesting changes. Please try again later.",
    "Subtitle": "Enter the planned budget per IV number here.",
    "Table": {
      "BudgetForApproval": "Budget for Approval",
      "InventoryNumber": "IV-No",
      "Name": "Name",
      "SubmittedBudget": "Submitted Budget",
      "Total": "Total"
    },
    "Title": "Enter Budget"
  },
  "Common": {
    "Approve": "Approve",
    "Cancel": "Cancel",
    "Complete": "Complete",
    "Delete": "Delete",
    "Edit": "Edit",
    "ErrorDeleteToast": "Error deleting {{ itemName }}.",
    "InventoryNumber": "IV-Number",
    "Months": {
      "Jan": "Jan",
      "Feb": "Feb",
      "Mar": "Mar",
      "Apr": "Apr",
      "May": "May",
      "Jun": "Jun",
      "Jul": "Jul",
      "Aug": "Aug",
      "Sep": "Sep",
      "Oct": "Oct",
      "Nov": "Nov",
      "Dec": "Dec"
    },
    "NoData": "No data available",
    "Pieces": "pcs.",
    "Placeholder": "Placeholder",
    "Required": "Required",
    "Save": "Save",
    "Search": "Search ...",
    "Select": "Select ...",
    "Submit": "Submit",
    "SuccessDeleteToast": "Successfully deleted {{ itemName }}.",
    "Sum": "Sum",
    "Unassigned": "Unassigned",
    "SelectAll": "Select all",
    "SelectedCount": "{{count}} selected"
  },
  "CheckInvestmentModal": {
    "AddEntry": "Add Entry +",
    "Amount": "Pieces",
    "Cost": "Cost",
    "Date": "Date",
    "EstimatedCost": "Estimated Cost",
    "NoEntries": "No tracking entries yet.",
    "QuantityExceeded": "The total number of pieces exceeds the planned quantity.",
    "RealCost": "Real Cost",
    "SaveError": "An error occurred while saving the tracking entries. Please try again later or contact support.",
    "Tracking": "Tracking",
    "TrackingEntries": "Tracking Entries"
  },
  "CompletePlan": {
    "Content": "You are about to complete this investment plan. Warning: this action cannot be undone.",
    "DisabledReasonLatestVersion": "Only the latest plan version can be completed.",
    "DisabledReasonMissingBudget": "Completion is only possible after an assigned budget has been set.",
    "DisabledReasonOverBudget": "Completion is not possible because the current investment sum exceeds the assigned budget.",
    "ErrorToastMessage": "Error completing plan. Please try again later.",
    "SuccessToastMessage": "Plan completed successfully.",
    "Title": "Complete Plan"
  },
  "Dashboard": {
    "AssignedBudget": "Assigned Budget",
    "Branch": "Branch",
    "Branches": "Branches",
    "Budget": "Budget",
    "BudgetByEntityCard": {
      "BudgetByFacility": "Budget By Facility",
      "BudgetByCountry": "Budget By Country"
    },
    "ClaimedBudget": "Claimed Budget",
    "DohCost": "DOH Cost",
    "Country": "Country",
    "CountryDialog": {
      "CountryBudgets": "Country Budgets",
      "EditBudget": "Edit Budget",
      "Subtitle": "Set the new budgets for the individual countries within this region.",
      "RemainingBudget": "Remaining Budget",
      "TotalAvailableBudget": "Total Available Budget",
      "SaveError": "Country budgets could not be updated. No changes were saved."
    },
    "BranchDialog": {
      "BranchBudgets": "Branch Budgets",
      "EditBudget": "Edit Budget",
      "SaveError": "Branch budgets could not be updated. No changes were saved.",
      "Subtitle": "Set the new budgets for the individual branches within this country.",
      "RemainingBudget": "Remaining Budget",
      "TotalAvailableBudget": "Total Available Budget",
      "Requested": "Requested"
    },
    "FiscalYear": "Fiscal Year",
    "FiscalYearDialog": {
      "CreateError": "An error occurred while creating the fiscal year. Please try again later or contact support.",
      "Deadline": "Deadline",
      "Subtitle": "Create a new fiscal year for this country.",
      "Title": "Create new Fiscal Year",
      "Year": "Year"
    },
    "PercentageBudget": "% of Budget",
    "PlanState": "Plan State",
    "ReadyForInvestplan": "Ready for Investplan",
    "NotReady": "Not Ready",
    "Region": "Region",
    "RegionDialog": {
      "CurrentBudget": "Current Budget",
      "EditBudget": "Edit Budget",
      "NewBudget": "New Budget",
      "Subtitle": "Set a new budget for this region."
    },
    "RemainingBudget": "Remaining Budget",
    "RequestedBudget": "Requested Budget",
    "TotalBudget": "Total Budget",
    "Track": {
      "BudgetByCategory": "Budget By Category",
      "UsedBudget": "Used Budget"
    }
  },
  "CreateCustomPlanItemModal": {
    "CreateError": "An error occurred while creating the custom plan item. Please try again later or contact support.",
    "Name": "Name",
    "Title": "New Custom Plan Item"
  },
  "DeleteCatalogItem": {
    "Content": "You are about to delete the catalog item '{{ itemName }}'. This action cannot be undone. Are you sure you want to proceed?",
    "Title": "Delete Catalog Item"
  },
  "DeleteCatalogItemTemplate": {
    "Content": "You are about to delete the catalog item template for '{{ itemName }}' in '{{ country }}'. This action cannot be undone. Are you sure you want to proceed?",
    "Title": "Delete Catalog Item Template"
  },
  "DeleteDirectOverhead": {
    "Content": "You are about to delete the DOH for '{{ itemName }}'. This action cannot be undone. Are you sure you want to proceed?",
    "Title": "Delete DOH"
  },
  "DeleteInvestment": {
    "Content": "You are about to delete the investment for '{{ itemName }}'. This action cannot be undone. Are you sure you want to proceed?",
    "Title": "Delete Investment"
  },
  "DirectOverheadCard": {
    "Doh": "DOH"
  },
  "DirectOverheadModal": {
    "CreateError": "An error occurred while creating the DOH. Please try again later or contact support.",
    "EstimatedCost": "Estimated Cost",
    "EstimatedDate": "Planned Realization Date",
    "Quantity": "Number of repairs needed",
    "TitleCreate": "New DOH",
    "TitleUpdate": "Update DOH",
    "UpdateError": "An error occurred while updating the DOH. Please try again later or contact support.",
    "UpdateTitle": "DOH: {{ name }}"
  },
  "ChangesRequestedMessageModal": {
    "Title": "Additional Message"
  },
  "EditColumnsSlideOver": {
    "HiddenColumns": "Hidden Columns",
    "HideAll": "Hide All",
    "ShowAll": "Show All",
    "Title": "Edit Columns",
    "VisibleColumns": "Visible Columns"
  },
  "EditInventoryNumbersSlideOver": {
    "Title": "Edit IV-Number Visibility"
  },
  "Filters": {
    "Category": "Category",
    "CategoryFinished": "Category is finished",
    "Columns": "Columns",
    "ColumnsVisible": "{{count}} visible",
    "Currency": "Currency",
    "GroupBy": "Group By",
    "HideWhen": "Hide When",
    "InvNumbers": "IV-Numbers",
    "InvNumber": "IV-Number",
    "InvNumbersSelected": "{{count}} selected",
    "ItemNotApplicable": "Item is Not Applicable"
  },
  "InvestmentCard": {
    "Investment": "Investment"
  },
  "InvestmentModal": {
    "CreateError": "An error occurred while creating the investment. Please try again later or contact support.",
    "Estimate": "Estimate",
    "EstimatedCost": "Estimated Cost YOP",
    "Estimated Date": "Planned Realization Date",
    "EstimatedDelivery": "Estimated Delivery",
    "InvestmentRealized": "Investment realized",
    "LifeTime": "Life Time",
    "LifeTimeWith": "Life Time with {{months}} months",
    "Months": "months",
    "Priority": "Priority",
    "RealizedCost": "Realized Cost",
    "Quantity": "Quantity",
    "ServiceLife": "Service Life",
    "Move": "Move",
    "MoveToNextYear": "Move to Next Year",
    "PostponeError": "An error occurred while postponing the investment. Please try again later or contact support.",
    "PostponeQuantity": "Number of Investments",
    "TitleCreate": "New Investment",
    "TitleUpdate": "Update Investment",
    "UpdateError": "An error occurred while updating the investment. Please try again later or contact support."
  },
  "InvestmentSummary": {
    "SubtitleApproved": "An overview of the selected investments.",
    "SubtitleChangesRequested": "An overview of the selected investments.",
    "SubtitleDraft": "An overview of the selected investments.",
    "SubtitleSubmitted": "An overview of completed investments.",
    "SubtitleCompleted": "An overview of completed investments.",
    "Table": {
      "Doh": "DOH",
      "InventoryNumber": "IV-Number",
      "Investments": "Investments",
      "Name": "Name",
      "Total": "Total"
    },
    "Title": "Investment Summary"
  },
  "MasterData": {
    "CatalogDetailsGrid": {
      "EditTemplates": "Edit Templates",
      "InvNumber": "IV-Number",
      "Name": "Name",
      "Templates": "Templates"
    },
    "CatalogGrid": {
      "Code": "Code",
      "Name": "Name"
    },
    "CountriesGrid": {
      "Code": "Code",
      "Division": "Division",
      "MainCurrency": "Main Currency",
      "Name": "Name",
      "SuccessToastEdit": "Country updated successfully."
    },
    "Currencies": {
      "AssignTitle": "Assign countries",
      "AssignmentError": "The country assignments could not be saved. Change the main currency first before removing it from a country.",
      "Code": "ISO currency code",
      "CodePlaceholder": "e.g. EUR",
      "Countries": "Assigned countries",
      "CreateError": "The currency could not be created. Check that the ISO code is valid and does not already exist.",
      "CreateTitle": "Create currency",
      "InvalidCode": "Enter a valid three-letter ISO 4217 code.",
      "MainCurrencySuffix": "Main Currency",
      "NewCurrency": "New currency",
      "SuccessAssignment": "Country assignments updated successfully.",
      "SuccessCreate": "Currency created successfully.",
      "Symbol": "Symbol",
      "Title": "Currencies"
    },
    "CreateFiscalYear": {
      "FiscalYearCreated": "Fiscal year created successfully.",
      "LatestPlanSubmissionDate": "Latest Plan Submission Date",
      "Title": "Create Fiscal Year",
      "Year": "Year"
    },
    "EditCatalogItemModal": {
      "Name": "Name",
      "Title": "Edit catalog item"
    },
    "EditCatalogCategoryModal": {
      "Name": "Name",
      "Title": "Edit catalog category"
    },
    "NewCatalogItemModal": {
      "ButtonTitle": "Catalog Item",
      "Category": "Category",
      "CategoryPlaceholder": "Select category",
      "InvNumber": "IV-Number",
      "Name": "Name",
      "Title": "New catalog item"
    },
    "NewCatalogCategoryModal": {
      "ButtonTitle": "Catalog Category",
      "Code": "Code",
      "CodeExists": "A catalog category with this code already exists in the division.",
      "CreateError": "The catalog category could not be created. Please try again later or contact support.",
      "Name": "Name",
      "Title": "New catalog category"
    },
    "NewFiscalYearModal": {
      "ButtonTitle": "New Fiscal Year",
      "LatestSubmissionDate": "Latest Submission Date",
      "Title": "New Fiscal Year"
    },
    "PlansGrid": {
      "FiscalYear": "Fiscal Year",
      "LatestSubmissionDate": "Latest Submission Date",
      "PlannedCountries": "Planned Countries",
      "Title": "Plans - Fiscal Years",
      "AlreadyPlanned": "Already planned",
      "ApplyToCountries": "Apply to countries",
      "ApplyToCountriesSubtitle": "Create plans for the selected countries. Countries that are already planned stay unchanged.",
      "ApplyToCountriesSuccess": "Fiscal year applied to the selected countries.",
      "ApplyToCountriesTitle": "Apply fiscal year to countries",
      "Countries": "Countries",
      "HeadsOfCountryNotified": "Heads of country notified",
      "LastNotifiedOn": "Last notified on {{date}}",
      "NoHeadOfCountry": "No head of country assigned",
      "NotNotifiedYet": "Not notified yet",
      "NotifyHeadsOfCountry": "Notify heads of country",
      "NotifyHeadsOfCountryError": "The heads of country could not be notified. Please try again later.",
      "NotifyHeadsOfCountryPartialError": "{{sent}} emails sent, {{failed}} could not be sent. Please try again later.",
      "NotifyHeadsOfCountrySubtitle": "Let the heads of country know that planning has started, so they assign the responsible warehouse managers to the branches.",
      "NotifyHeadsOfCountrySuccess": "Notification sent to {{count}} heads of country.",
      "NotifyHeadsOfCountryTitle": "Notify heads of country – {{year}}",
      "SendNotification": "Send notification"
    },
    "Sidebar": {
      "Catalog": "Catalog",
      "Countries": "Countries",
      "Currencies": "Currencies",
      "Plans": "Plans",
      "Users": "Users"
    },
    "Users": {
      "Title": "User Assignments",
      "DivisionUsers": "Division Users",
      "RegionalDirectors": "Regional Directors",
      "HeadsOfCountry": "Heads of Country",
      "BranchWorkers": "Workers",
      "NoUsers": "No users assigned",
      "LoadError": "Failed to load user hierarchy. Please try again later.",
      "AddUser": "Add user",
      "RemoveUser": "Remove user",
      "SelectUser": "Select user",
      "NoAvailableUsers": "No users available to assign",
      "AssignUser": "Assign user",
      "AssignSuccess": "User successfully assigned.",
      "RemoveSuccess": "User successfully removed.",
      "RemoveUserConfirm": "Are you sure you want to remove {{name}}?",
      "RemoveBranchUserWarning": "Are you sure you want to remove {{name}}? This will also remove the user from all plans of this branch.",
      "SyncDistributionLists": "Sync distribution lists",
      "SyncDistributionListsHint": "Reads the distribution lists from the user import again and updates the assignments of their members. Runs automatically every night.",
      "SyncDistributionListsSuccess": "{{synced}} distribution lists synced: {{added}} assignments added, {{removed}} removed.",
      "SyncDistributionListsSkipped": "{{failed}} distribution lists could not be read or were empty and were skipped.",
      "SyncDistributionListsError": "The distribution lists could not be synced. Please try again later."
    },
    "TemplatesGrid": {
      "Cost": "Cost",
      "Country": "Country",
      "Currency": "Currency",
      "Lifetime": "Life Time",
      "EstimatedDelivery": "Estimated Delivery",
      "NewTemplate": "New Template"
    },
    "TemplateSlideOver": {
      "AvailabilityState": "Availability State",
      "Cost": "Cost",
      "Country": "Country",
      "CreateTitle": "New Catalog Template",
      "Currency": "Currency",
      "DeliveryTime": "Delivery Time",
      "DeliveryTimePlaceholder": "up to 3 months",
      "Lifetime": "Life Time",
      "MonthsUnit": "months",
      "SaveError": "The template could not be saved. A catalog item can only have one template per country.",
      "UpdateTitle": "Edit Catalog Template"
    },
    "ToOverview": "Overview"
  },
  "MyTasks": {
    "ActionRequired": "Action required",
    "Activities": "Activities",
    "ActivityTable": {
      "AssignedBudget": "Assigned Budget",
      "Country": "Country",
      "CurrentState": "Current State",
      "Facility": "Facility",
      "Region": "Region",
      "RequestedBudget": "Requested Budget",
      "Version": "Version"
    },
    "Title": "Good afternoon, {{ name }}!",
    "TitleNoName": "Good afternoon!",
    "NoTasks": "No actions required."
  },
  "Overview": {
    "Grid": {
      "AssignedBudget": "Assigned Budget",
      "DohCost": "DOH Cost",
      "Expand": "Expand",
      "FiscalYear": "Fiscal Year",
      "OpenPlan": "Open Plan",
      "RequestedBudget": "Requested Budget",
      "SharePlan": "Share Plan",
      "SharePlanSuccessToastMessage": "Plan shared successfully.",
      "State": "State",
      "Versions": "Versions",
      "VersionsAmount": "{{count}} Versions"
    },
    "Header": {
      "BusinessYear": "Business Year {{ year }}",
      "NoLocationSelected": "No location selected",
      "Plan": "Plan",
      "SubmissionUntil": "Submission until {{ date }}",
      "Track": "Track"
    },
    "InvitedMembers": {
      "Member": "Member",
      "InviteButton": "Invite Member",
      "InvitedBy": "Invited By",
      "InvitedOn": "Invited On",
      "LatestSubmissionDate": "Latest Submission Date for Plan",
      "Name": "Name",
      "ForYearTitle": "Invited Members for {{ year }}"
    },
    "NoSelection": "Please select a branch to view its investment plans.",
    "Sidebar": {
      "Locations": "Locations"
    },
    "Tasks": {
      "Grid": {
        "Branch": "Branch",
        "DueDate": "Due Date",
        "FiscalYear": "Fiscal Year",
        "State": "State"
      },
      "MyTasks": "My Tasks"
    }
  },
  "Plan": {
    "CommentsSendError": "The message could not be sent. Please try again later.",
    "CommentsTitle": "Comments",
    "CommentsTypeMessage": "Type your message ...",
    "DirectOverhead": "DOH",
    "Grid": {
      "AddOtherItem": "Add Other Item",
      "CollapseAll": "Collapse All",
      "Comment": "Comment",
      "Comments": "Comments",
      "DirectOverheads": "DOHs",
      "DOHSum": "DOH Sum",
      "ExpandAll": "Expand All",
      "Investments": "Investments",
      "IvNumber": "IV-Number",
      "Name": "Name",
      "NumberOfPositions": "Number of Positions",
      "State": "State"
    },
    "Header": {
      "Approve": "Approve",
      "ChangeBudget": "Request Changes",
      "Completed": "Completed",
      "DenyBudget": "Deny Budget",
      "FiscalYear": "Fiscal Year {{year}}",
      "ShowChangesRequestedMessage": "Show additional message",
      "Submitted": "Submitted"
    },
    "Investment": "Investment",
    "InvestmentsView": {
      "AllInvestments": "All investments",
      "Amount": "Amount",
      "Branch": "Branch",
      "Catalog": "Catalog",
      "Investment": "Investment",
      "NoInvestments": "No investments are planned yet.",
      "NoMatchingResults": "No investments match the current search and filters.",
      "NoPriority": "No priority",
      "PlannedDate": "Planned date",
      "Priority": "Priority",
      "Quantity": "Quantity",
      "TabsLabel": "Plan views",
      "TotalAmount": "Total amount"
    },
    "MovementsSidebar": {
      "AddToPlan": "Add to Plan",
      "ApplyConfirm": "Are you sure you want to apply this postponed investment to the current plan?",
      "ApplyError": "An error occurred while applying the postponed investment. Please try again later or contact support.",
      "ApplySuccess": "Successfully applied plan movement for {{name}}.",
      "ApplyTitle": "Apply Postponed Investment",
      "EmptyFrom": "No planned investments for this year",
      "EmptyTo": "No postponed investments for the upcoming year",
      "EstimatedCost": "Estimated Cost",
      "FromYear": "From {{ year }}",
      "LifeTime": "Life Time",
      "Name": "Name",
      "Priority": "Priority",
      "Quantity": "Quantity",
      "Restore": "Restore",
      "RestoreConfirm": "Are you sure you want to restore this postponed investment back to the current plan?",
      "RestoreError": "An error occurred while restoring the postponed investment. Please try again later or contact support.",
      "RestoreSuccess": "Successfully restored plan movement for {{name}}.",
      "RestoreTitle": "Restore Postponed Investment",
      "Title": "Plan Movements",
      "ToYear": "To {{ year }}",
      "IncomingBadgeTooltip": "{{count}} postponed investment(s) from {{year}}"
    },
    "Sidebar": {
      "Filter": "Filter"
    }
  },
  "RequestChangesModal": {
    "Confirm": "Request Changes",
    "Content": "You are about to request changes for this investment plan. You can optionally add an additional message below.",
    "ErrorToastMessage": "Error requesting changes. Please try again later.",
    "MessageLabel": "Additional message for branch (optional)",
    "MessagePlaceholder": "Add more context for the branch ...",
    "SuccessToastMessage": "Changes requested successfully.",
    "Title": "Request Changes"
  },
  "PriorityState": {
    "High": "High",
    "Low": "Low",
    "Medium": "Medium"
  },
  "Routes": {
    "Home": "Home",
    "Dashboard": "Dashboard"
  },
  "SharePlan": {
    "Content": "{{ year }} Investment plan for {{ branchName }}",
    "Email": "Recipient Email",
    "LatestSubmissionDate": "Latest Submission Date",
    "Recipients": "Recipients",
    "Title": "Share Plan",
    "SaveError": "The plan could not be shared. Please check the email addresses."
  },
  "Sidebar": {
    "MyTasks": "My Tasks",
    "Plan": "Plan",
    "Settings": "Settings"
  },
  "State": {
    "Approved": "Approved",
    "ChangesRequested": "Changes Requested",
    "Completed": "Completed",
    "Draft": "Draft",
    "Submitted": "Submitted"
  },
  "SubmitPlan": {
    "Content": "You are about to submit this investment plan for approval. Once submitted, you will not be able to make further changes to this plan until it has been reviewed.",
    "ErrorToastMessage": "Error submitting plan. Please try again later.",
    "SuccessToastMessage": "Plan submitted successfully.",
    "Title": "Submit Plan"
  },
  "UserContext": {
    "Logout": "Logout",
    "AdminCatalogManagement": "Admin - Catalog management"
  }
}
